"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useChannelSelectionData = exports.useItemTypes = void 0;
const react_redux_1 = require("react-redux");
const merlin_hooks_1 = require("@travelnest/merlin-hooks");
// @ts-ignore https://github.com/microsoft/TypeScript/issues/42790
const useItemTypes = (entityActions) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const itemTypes = (0, react_redux_1.useSelector)((state) => state.data.itemTypes);
    const loading = (0, merlin_hooks_1.useDataLoad)(!Object.keys(itemTypes).length, () => __awaiter(void 0, void 0, void 0, function* () { return yield dispatch(entityActions.itemTypes.getItemTypes()); }));
    return { loading, itemTypes };
};
exports.useItemTypes = useItemTypes;
const useChannelSelectionData = (entityActions, customer) => {
    const dispatch = (0, react_redux_1.useDispatch)();
    const channelData = (0, react_redux_1.useSelector)((state) => state && state.data.listingContracts.byCustomerId[customer.id]);
    const loading = (0, merlin_hooks_1.useDataLoad)(channelData === undefined, () => __awaiter(void 0, void 0, void 0, function* () { return yield dispatch(entityActions.listingContracts.getByCustomer(customer.id)); }));
    return { loading, channelData };
};
exports.useChannelSelectionData = useChannelSelectionData;
//# sourceMappingURL=data.js.map